var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93988 1.66797C14.5417 1.66797 18.2729 5.39917 18.2729 10.001C18.2727 14.6026 14.5416 18.332 9.93988 18.332C5.85238 18.3317 2.45451 15.3899 1.74456 11.5078C1.6412 10.942 2.01578 10.3985 2.58148 10.2949C3.14727 10.1916 3.68986 10.5671 3.79339 11.1328C4.3255 14.0432 6.87631 16.2487 9.93988 16.249C13.391 16.249 16.1897 13.452 16.1899 10.001C16.1899 6.54977 13.3911 3.75195 9.93988 3.75195C8.51884 3.7521 7.21063 4.22697 6.16058 5.02637H7.13714C7.71207 5.02666 8.17796 5.49341 8.17816 6.06836C8.17816 6.64366 7.71146 7.11035 7.13617 7.11035H4.02777C3.3375 7.11035 2.77693 6.55059 2.77679 5.86035V2.75195C2.77679 2.17666 3.24446 1.70898 3.81976 1.70898C4.39466 1.70935 4.86064 2.17602 4.86077 2.75098V3.39746C6.26644 2.31475 8.02798 1.66812 9.93988 1.66797Z",
    fill: "#146EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.026110c0a55cdf3ba8f81cffbd2b8735.svg";
export { ForwardRef as ReactComponent };